import { browser } from '$app/environment';
import { beforeNavigate } from '$app/navigation';
import { m } from '$lib/paraglide/messages';

export interface Notification {
	type: 'info' | 'success' | 'error' | 'warning';
	message: string;
}

export default class NotificationProvider {
	notifications = $state<Notification[]>([]);

	constructor() {
		beforeNavigate(() => {
			if (!browser) return;

			this.clear();
		});
	}

	add(notification: Notification) {
		this.notifications = [...this.notifications, notification];
		window.scrollTo(0, 0);
	}

	addUnknown() {
		this.add({
			type: 'error',
			message: m['errors.unknown.message'](),
		});
	}

	clear() {
		this.notifications = [];
	}
}
